import { type NotificationGroupDTO } from '@eppendorf/vnls-notifications-utils';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { Trans } from 'react-i18next';

import { getFormattedLocalizedDateTimeWithSeconds } from '$shared/utils/date.utils';

type IncidentFlowItemProps = {
  notificationGroup: NotificationGroupDTO;
};

export function IncidentDetailGroupContent({ notificationGroup }: IncidentFlowItemProps) {
  const {
    firstNotificationAt,
    lastNotificationAt,
    notificationCountInBetween,
    recipients,
  } = notificationGroup;

  return (
    <div className="flex gap-l flex__dir--column flex__ai--center">
      {(firstNotificationAt || lastNotificationAt || notificationCountInBetween) && (
        <div className="flex gap-m flex__dir--column text-align-center">
          {firstNotificationAt &&
            getFormattedLocalizedDateTimeWithSeconds(firstNotificationAt)}
          {notificationCountInBetween > 0 && (
            <div className="flex flex__ai--center flex__jc--center">
              <Icon name="messages-divider-line" size={IconSizeClasses.XSmall} />
              <span className="font-weight-medium">
                <Trans
                  i18nKey="incidents.incidentsCounter"
                  values={{ count: notificationCountInBetween }}
                />
              </span>
            </div>
          )}
          {lastNotificationAt > 0 && (
            <div>{getFormattedLocalizedDateTimeWithSeconds(lastNotificationAt)}</div>
          )}
        </div>
      )}
      {recipients?.length > 0 && (
        <div className="flex gap-s flex__dir--column">
          {recipients.map((recipient) => (
            <div key={recipient.id} className="font-weight-semibold">
              {recipient.firstName} {recipient.lastName}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
